import { Interceptor, runMiddleware } from './utils/http';
import { nbChannels } from './api/nb';
import { sentOtp, validateOtp, logout } from './api/login';
import { cardDetails, directApi } from './api/card';
import {
  emiDetails,
  emiSubventionBanks,
  emiSubventionPlans,
  emiSubventionValidatePlan
} from './api/emi';
import { vpaDetails, validateVPA } from './api/upi';
import { promoDetails } from './api/promo';
import { config, configPayload } from './api/merchant';
import { payload } from './api/request';
import { balance, payModes, pay, status, tokenPaymodes } from './api/paytm';
import { ERRORS } from './constant';
import { fetchPcfDetails } from './api/pcf';
import { pubsubLogger } from './utils/logger';
import { applyPromo } from './api/offers';
import { validateIfsc, getIfsc } from './api/bank-mandate';
import { validatePRN } from './api/prn';
import { getCacheCardToken } from './api/sc';

/*
 * A private method for binding mid,orderid, token and token type
 *
 * @param {string} mid - merchant id
 * @param {string} orderId - order id
 * @param {string} token - token
 * @param {string} [type] - token type
 *
 * @return {Function} - callback function to register on interceptors with http request as parameter
 * */
const _bindOptions = (mid, orderId, token, type) => {
  return request => {
    request.query.mid = mid;
    request.query.orderId = orderId;

    if (request.data) {
      if (request.data.head) {
        request.data.head.token = token || '';
        request.data.head.type = type || '';
      }
      if (request.data.body) {
        request.data.body.mid = mid;
      }
    }
    return request;
  };
};

/**
 * A module wrapper over paytm native api that can be access via javascript functions.
 *
 * @example var paytmApi = new Paytm.API(mid: String, orderId: String, txnToken: String, options: Object)
 * @param {string} mid - merchant id
 * @param {string} orderId - order id
 * @param {string} token - transaction token
 * @param {Object} [options] - optional js object that contains meta data
 * @param {string} options.type - token type - SSO , TXN_TOKEN
 */
export function API(mid, orderId, token, options) {
  if (!mid) {
    throw new Error(ERRORS.CHECKOUT);
  }

  this.middleware = new Interceptor();
  this.postFetch = new Interceptor();
  this.middleware.add(_bindOptions(mid, orderId, token, (options && options.type) || ''));
}

API.prototype.runMiddleware = runMiddleware;
API.prototype.sendOtp = sentOtp;
API.prototype.verifyOtp = validateOtp;
API.prototype.logout = logout;
API.prototype.balance = balance;
API.prototype.nbChannels = nbChannels;
API.prototype.cardDetails = cardDetails;
API.prototype.tokenPaymodes = tokenPaymodes;
API.prototype.emiDetails = emiDetails;
API.prototype.pay = pay;
API.prototype.payModes = payModes;
API.prototype.upiVpa = vpaDetails;
API.prototype.verifyVPA = validateVPA;
API.prototype.promoDetails = promoDetails;
API.prototype.configPayload = configPayload;
API.prototype.config = config;
API.prototype.fetchPcfDetails = fetchPcfDetails;
API.prototype.status = status;
API.prototype.requestPayload = payload;
API.prototype.logger = pubsubLogger;
API.prototype.applyPromo = applyPromo;
API.prototype.directApi = directApi;
API.prototype.validatePRN = validatePRN;

API.prototype.emiSubventionBanks = emiSubventionBanks;
API.prototype.emiSubventionPlans = emiSubventionPlans;
API.prototype.emiSubventionValidatePlan = emiSubventionValidatePlan;
API.prototype.getCacheCardToken = getCacheCardToken;
API.prototype.validateIfsc = validateIfsc;
API.prototype.getIfsc = getIfsc;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api.js